import { startggConfig } from "./startggConfig";

/**
 * start.gg OAuth (authorization code flow) の authorize URL を組み立てる。
 * CSRF 対策の state（nonce）を sessionStorage に保存し、callback で照合する。
 */
const STATE_STORAGE_KEY = "startgg_oauth_state";

export const buildStartggAuthorizeUrl = (): string => {
  const state = generateNonce();
  sessionStorage.setItem(STATE_STORAGE_KEY, state);
  const params = new URLSearchParams({
    response_type: "code",
    client_id: startggConfig.clientId,
    scope: startggConfig.scope,
    redirect_uri: startggConfig.redirectUri,
    state,
  });
  return `${startggConfig.authorizeEndpoint}?${params.toString()}`;
};

/**
 * callback で受け取った state を保存済みの値と照合し、使い捨てる。
 * 一致すれば true。保存が無い / 不一致なら false。
 */
export const consumeStartggState = (received: string | null): boolean => {
  const saved = sessionStorage.getItem(STATE_STORAGE_KEY);
  sessionStorage.removeItem(STATE_STORAGE_KEY);
  return saved !== null && saved === received;
};

const generateNonce = (): string => {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
};
